import { ButtonHTMLAttributes } from 'react';
import cx from 'classnames';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: 'light' | 'dark';
}

export function PlayButton({ theme = 'light', className, ...props }: Props) {
  return (
    <button
      className={cx(
        'group relative flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-[#FF9446] active:opacity-70',
        theme === 'light'
          ? 'bg-[#003835] text-[#00D9B4]'
          : 'bg-[#00D9B4] text-[#003835]',
        className
      )}
      tabIndex={0}
      {...props}
    >
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transform transition-transform duration-300 ease-in-out group-hover:translate-x-[6px]"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.5 2L16.5 9.5L4.5 17V2Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
}
